import { withInstall } from '@chenms-zj/utils/with-install'
import _Slider from './src/slider.vue'

export const Slider = withInstall(_Slider)
export default Slider

export * from './src/slider'

// 声明模块
declare module 'vue' {
  export interface GlobalComponents {
    CmsSlider: typeof Slider
  }
}